import React from "react";
import { useDispatch } from "react-redux";
import { NavLink, useMatch, useNavigate } from "react-router-dom";
import { changeFilterType } from "../features/filter/filterSlice";

const Sidebar = () => {
  const dispatch = useDispatch();

  const homepage = useMatch("/");
  const navigate = useNavigate();
  const handleFilterType = (type) => {
    dispatch(changeFilterType(type));
    if (!homepage) {
      navigate("/");
    }
  };

  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <NavLink
              to="/"
              onClick={() => handleFilterType("all")}
              className={({ isActive }) =>
                `main-menu ${isActive ? "menu-active" : ""} lws-allJob`
              }
            >
              <i className="fa-solid fa-briefcase"></i>
              <span> All Available Jobs</span>
            </NavLink>
            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <button
                  className="sub-menu"
                  onClick={() => handleFilterType("Internship")}
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]"></i>
                  Internship
                </button>
              </li>
              <li>
                <button
                  className="sub-menu"
                  onClick={() => handleFilterType("Full Time")}
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]"></i>
                  Full Time
                </button>
              </li>
              <li>
                <button
                  className="sub-menu"
                  onClick={() => handleFilterType("Remote")}
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4]"></i>
                  Remote
                </button>
              </li>
            </ul>
          </li>
          <li>
            <NavLink
              to="/add-job"
              className={({ isActive }) =>
                `main-menu ${
                  isActive ? "menu-active" : ""
                } lws-AddJob`
              }
            >
              <i className="fa-solid fa-file-circle-plus"></i>
              <span>Add NewJob</span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
